import { FEATURE_FLAG_DOMAIN } from '@heidi/runtime/feature-flags';
import { OpenFeature, useBooleanFlagValue } from '@openfeature/react-sdk';

/**
 * Kill switch for the desktop start fence: a user stop or pause fencing the
 * session's start still in flight, and a fenced user start standing down. ON
 * restores the earlier behaviour without a desktop release.
 *
 * Default OFF, and an unresolved flag reads OFF, so the fence stays active. Kill
 * switch, not an experiment: do not add `useManualExposure`.
 */
export const USER_START_FENCE_KILL_FLAG_KEY = 'op-apps-disable-user-start-fence-desktop';

export const useIsUserStartFenceKilled = (): boolean =>
  useBooleanFlagValue(USER_START_FENCE_KILL_FLAG_KEY, false);

/** Imperative read for a mutation body; safe with no provider mounted. */
export const isUserStartFenceKilled = (): boolean =>
  OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(
    USER_START_FENCE_KILL_FLAG_KEY,
    false
  );
